import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import Header from '../common/Header';
import blendersImage from '../../assets/images/blender.jpg';
import dispenserImage from '../../assets/images/dispenser.jpg';
import acImage from '../../assets/images/AC.jpg';
import { GoArrowLeft, GoArrowRight } from "react-icons/go";
import { useLanguage } from '../../store/languageContext';
import translate from '../../utils/translation';
const Services = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const sectionRef = useRef(null);
    const { language, setNavColor } = useLanguage();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('black');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);
    const services = [
        {
            title: translate[language]['serviceTitle1'],
            description: translate[language]['serviceText3'],
            image: blendersImage
        },
        {
            title: translate[language]['serviceTitle2'],
            description: translate[language]['serviceText3'],
            image: dispenserImage
        },
        {
            title: translate[language]['serviceTitle3'],
            description: translate[language]['serviceText3'],
            image: acImage
        },
    ];

    return (
        <section id="services" ref={sectionRef} className="container mx-auto landing-section pb-8 sm:pb-[50px] flex flex-col px-4 sm:px-6" >
            <Header text={translate[language]["servicesHeader"]} />
            <div className="flex flex-col md:flex-row gap-6 md:gap-8 flex-1">
                <div className="w-full md:w-1/3 opacity-75 order-2 md:order-1">
                    <motion.img
                        key={activeIndex}
                        src={services[activeIndex].image}
                        alt={services[activeIndex].title}
                        className="w-full h-[250px] sm:h-[320px] md:h-full object-cover rounded-[30px] sm:rounded-[50px] shadow-lg"
                        initial={{ y: 150, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                        viewport={{ once: true }}
                    />
                </div>
                <div className="w-full md:w-2/3 flex flex-col justify-between items-start md:items-center order-1 md:order-2">
                    <div className='w-full md:w-4/5 lg:w-1/2'>
                        <motion.h2
                            initial={{ y: 100, opacity: 0 }}
                            whileInView={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                            viewport={{ once: true }}
                            className='text-3xl sm:text-4xl md:text-5xl lg:text-[60px] leading-tight lg:leading-[60px] font-semibold mb-4'>
                            {translate[language]["servicesTitle1"]}
                        </motion.h2>
                        <motion.p
                            initial={{ y: 50, opacity: 0 }}
                            whileInView={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.5, delay: 0.4, ease: 'easeOut' }}
                            viewport={{ once: true }}
                            className='opacity-[0.5] text-sm sm:text-base'>
                            {translate[language]["servicesTitle2"]} <br />
                            {translate[language]["servicesTitle3"]}
                        </motion.p>
                    </div>
                    <motion.div
                        initial={{ y: 100, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.4, ease: 'easeOut' }}
                        viewport={{ once: true }}
                        className='w-full md:w-4/5 lg:w-1/2 mt-6 md:mt-0'>
                        {services.map((service, index) => (
                            <div key={index} className={`font-semibold py-2 ${language === 'ar' ? 'border-r-[2px] pr-4 sm:pr-[36px]' : 'border-l-[2px] pl-4 sm:pl-[36px]'} ${activeIndex === index ? 'border-[#589EEE]' : 'border-transparent'}`}>
                                <div className='flex flex-col pb-3 sm:pb-4 border-b'>
                                    <div
                                        onClick={() => setActiveIndex(index)}
                                        className={`w-full flex justify-between items-center pb-2 sm:pb-[15px] cursor-pointer ${language === 'ar' ? 'text-right' : 'text-left '}`}
                                    >
                                        <span className="uppercase flex-1 text-lg sm:text-xl md:text-2xl">
                                            {service.title}
                                        </span>
                                        <span className={`border size-8 sm:size-[36px] min-w-8 sm:min-w-[36px] rounded-full p-1 flex items-center justify-center ${activeIndex === index ? 'bg-[#589EEE] text-white' : ''}`}>
                                            {language === 'ar' ? <GoArrowLeft /> : <GoArrowRight />}
                                        </span>
                                    </div>
                                    {activeIndex === index && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: 'auto', opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.5 }}
                                            className="overflow-hidden "
                                        >
                                            <p className='opacity-50 text-sm sm:text-base'>{service.description}</p>
                                        </motion.div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export { Services };